// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SearchResults":"jg_a bhl_a bhl_j bhl_q bhl_sv bhl_sw bhl_w"};